import { defineStore } from 'pinia';

export const useLogStore = defineStore('log', () => {
    // #region LOG

    function log(text, type = '') {
        var color;

        switch (type) {
            case 'info':
                color = 'background-color: #4caf50; #ffffff';
                break;
            case 'warning':
                color = 'background-color: #e1771d; #ffffff';
                break;
            case 'error':
                color = 'background-color: #f44336; #ffffff';
                break;

            default:
                color = 'background-color: #ccc; #000000';
                break;
        }

        console.log(`%c[LOG] ${text}.`, color);
    }

    // #endregion

    return {
        // log
        log,
    };
});
